import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent  {

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }



  onConfirm(): void {
    this.dialogRef.close();
  }




  isMamSncf(){
    if(location.host === 'mam.clem.mobi' || location.host === `www.mam.clem.mobi` ) 
    {
      return true
  
    }else
    {
      return false
    }
  }

  
}
